import React, { useState, useEffect } from 'react';
import '../../styles/Payment.css';
import { processPayment, getPayments } from '../../services/api';

function Payment() {
  const [amount, setAmount] = useState('');
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const data = await getPayments();
        setPayments(data);
      } catch (err) {
        console.error('Failed to fetch payments:', err);
      }
    };
    fetchPayments();
  }, []);

  const handlePayment = async (e) => {
    e.preventDefault();
    try {
      const paymentData = { amount: parseFloat(amount), date: new Date().toISOString() };
      await processPayment(paymentData);
      setPayments([...payments, { id: payments.length + 1, service: 'Pending', ...paymentData }]);
      setAmount('');
      alert('Payment processed successfully!');
    } catch (err) {
      alert('Payment failed. Please try again.');
    }
  };

  return (
    <div className="sp-payment">
      <h2 className="sp-payment-title">Payments</h2>
      <form className="sp-payment-form" onSubmit={handlePayment}>
        <input
          className="sp-payment-input"
          type="number"
          placeholder="Enter amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          required
        />
        <button className="sp-payment-btn" type="submit">Make Payment</button>
      </form>
      <h3 className="sp-payment-history-title">Payment History</h3>
      <ul className="sp-payment-list">
        {payments.map((payment) => (
          <li key={payment.id} className="sp-payment-item">
            <span>{payment.service} - ${payment.amount}</span>
            <span>{new Date(payment.date).toLocaleDateString()}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Payment;